import { PropsWithChildren } from "react";
import "./GridView.css";
import SearchBar from "../SearchBar/SearchBar";
import ListView from "../ListView/ListView";

export type IDataSource<T> = {
  count: number;
  data: T;
};

enum DisplayMode {
  GridView,
  ListView,
}

export type GridViewProps<T> = PropsWithChildren<T> & {
  showSearchBar?: boolean;
  showAddButton?: boolean;
  context?: string;
  onAddRecord?: () => void;
  onDeleteRecord?: (record: T | T[] | undefined) => void;
  onEditRecord?: (record: T | T[] | undefined) => void;
  onRecordSelected?: (record: T) => void;
  onPageChanged?: (page?: number) => void;
  onSearchValueChanged?: (searchValue: string) => void;
  onSearchClick?: () => void;
  displayMode?: DisplayMode;
};

type GridViewHeaderProps = PropsWithChildren & {};
const GridViewHeader = (props: GridViewHeaderProps) => <>{props.children}</>;

type GridViewFooterProps = PropsWithChildren & {};
const GridViewFooter = (props: GridViewFooterProps) => <>{props.children}</>;

type GridViewContentProps = PropsWithChildren & {};
const GridViewContent = (props: GridViewContentProps) => <>{props.children}</>;

// creates a table shell that can be reused on different pages of the application!
function GridView<T>(props: GridViewProps<T>) {
  const displayGrid = () => {
    if (props.displayMode === DisplayMode.GridView) {
      return (
        <div className="table-responsive">
          <table className="table table-condensed">{props.children}</table>
        </div>
      );
    }

    //For now display the same list of items... till listview is implemented!
    debugger;
    return (
      <div className="table-responsive">
        <table className="table table-condensed">{props.children}</table>
      </div>
    );
  };

  const displayData = () => (
    <div className="grid-view">
      {props.showSearchBar && (
        <SearchBar
          context={props.context}
          onAddRecord={props.onAddRecord}
          onSearchValueChanged={props.onSearchValueChanged}
          onClick={props.onSearchClick}
          showAddButton={props.showAddButton}
        />
      )}

      {displayGrid()}
    </div>
  );

  return displayData();
}

GridView.Content = GridViewContent;
GridView.Header = GridViewHeader;
GridView.Footer = GridViewFooter;

export default GridView;
